import moment from "moment";
import * as yup from "yup";
import {
  DATE_OF_EVENT,
  DEPARTMENT,
  DOCUMENTS,
  FUND_TYPE,
  IS_EDITABLE,
  IS_FUNDED,
  IS_INPUT_OPENED,
  IS_TERMS_ACCEPTED,
  LABEL,
  MICR,
  PRINCIPAL_INVESTIGATOR,
  CO_INVESTIGATOR,
  PROTOCOL_NUMBER,
  PROTOCOL_NUMBER_OTHERS,
  REQUIRED,
  SPONSOR,
  STUDY_PHASE,
  TITLE,
  TYPE_OF_PV_PD,
  TYPE_OF_STUDY,
  _URL,
  DROPDOWN_VALUES,
  DROPDOWN_SELECTED_VALUE,
} from "../../../constants/forms";

export const InitialReviewInitData = {
  [PROTOCOL_NUMBER]: "",
  [PROTOCOL_NUMBER_OTHERS]: "",
  [MICR]: "",
  [TITLE]: "",
  [SPONSOR]: "",
  [PRINCIPAL_INVESTIGATOR]: "",
  [CO_INVESTIGATOR]: "",
  [DEPARTMENT]: "",
  [STUDY_PHASE]: "",
  [TYPE_OF_STUDY]: "",
  [FUND_TYPE]: "",
  [IS_TERMS_ACCEPTED]: false,
  [DOCUMENTS]: [
    {
      [LABEL]: "Cover letter Signed by PI",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Study Protocol ",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Informed consent document",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: ['English', 'Hindi'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "ICD Back translated document",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]:
        "Informed consent document translation and back translation certificates",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "IB/ Package insert/Device manuals/ publication support ",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Investigator's undertaking ",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Signed and dated CV, GCP, MRC ",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Case report form",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "DCGI approval",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "DCGI acknowledgment",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Clinical trial registration details",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Clinical trial agreement",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Clinical trial MoU",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Insurance policy",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Import license",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: ['Drug import from outside the country', 'Manufacturer of IP', 'Source of IP', 'Good Manufacturing Practices certificate'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "DGFT Certificate",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]:
        "Patient diary cards/ health questionnaires (Translation and back translations certificate)",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "Financial disclosure by investigator",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "EC fees",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: ['Under Process','Paid', 'Waiver'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "MIRB recommendation",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
    {
      [LABEL]: "EC Presentation (As per Medanta Template)",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: [],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
  ],
};

const IRStudyDetailsStepValidation = yup.object().shape({
  [PROTOCOL_NUMBER]: yup.string().required("Protocol is required"),
  [MICR]: yup.string().required("MICR is required"),
  [TITLE]: yup.string().required("Study title is required"),
  [SPONSOR]: yup.string().required("Sponsor name is required"),
  [PRINCIPAL_INVESTIGATOR]: yup
    .string()
    .required("Principal investigator name is required"),
  [DEPARTMENT]: yup.string().required("Department is required"),
  [STUDY_PHASE]: yup.string().nullable().required("Study phase is required"),
  [TYPE_OF_STUDY]: yup.string().required("Types of study is required"),
  [FUND_TYPE]: yup.string(),
  [IS_TERMS_ACCEPTED]: yup
    .boolean()
    .isTrue("Please accept the terms first.")
    .required("Please accept the terms first."),
});

const irbSubmissionStepValidation = yup.object().shape({
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        [LABEL]: yup.string().required("Label is required"),
        [REQUIRED]: yup.boolean().required(),
        [_URL]: yup.string().when(REQUIRED, {
          is: true,
          then: yup.string().test(_URL, function (value) {
            const label = this.parent[LABEL] || "";
            return (
              Boolean(value) ||
              this.createError({ message: `Please add ${label} document` })
            );
          }),
          otherwise: yup.string(),
        }),
      })
    )
    .required("At least one document is required")
    .min(1),
});

export const IRBSubmissionValidationSchema = [
  IRStudyDetailsStepValidation,
  irbSubmissionStepValidation,
];

// ********************************************

export const AdditionalDocumentInitData = {
  protocolNumber: "",
  micr: "",
  title: "",
  sponsor: "",
  principalInvestigator: "",
  [CO_INVESTIGATOR]: "",
  department: "",
  studyPhase: "",
  typeOfStudy: "",
  fundType: "",
  isTermsAccepted: false,
  documents: [
    {
      label: "Cover letter",
      required: true,
      url: "",
      isEditable: false,
      isInputOpened: false,
    },
    {
      label: "EC fees",
      required: true,
      url: "",
      isEditable: false,
      isInputOpened: false,
      [DROPDOWN_VALUES]: ['Under Process','Paid', 'Waiver'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
  ],
};

// ***********************************************

export const ECNotificationInitData = {
  [PROTOCOL_NUMBER]: "",
  [MICR]: "",
  [TITLE]: "",
  [SPONSOR]: "",
  [PRINCIPAL_INVESTIGATOR]: "",
  [CO_INVESTIGATOR]: "",
  [DEPARTMENT]: "",
  [STUDY_PHASE]: "",
  [TYPE_OF_STUDY]: "",
  [FUND_TYPE]: "",
  [IS_TERMS_ACCEPTED]: false,
  [DOCUMENTS]: [
    {
      label: "Cover letter",
      required: true,
      url: "",
      isEditable: false,
      isInputOpened: false,
    },
  ],
};

// ***********************************************
export const ECAnnualReportInitData = {
  protocolNumber: "",
  micr: "",
  title: "",
  sponsor: "",
  principalInvestigator: "",
  [CO_INVESTIGATOR]: "",
  department: "",
  studyPhase: "",
  typeOfStudy: "",
  fundType: "",
  isTermsAccepted: false,
  documents: [
    {
      label: "Annual Report",
      required: true,
      url: "",
      isEditable: false,
      isInputOpened: false,
    },
    {
      label: "EC fees",
      required: true,
      url: "",
      isEditable: false,
      isInputOpened: false,
      [DROPDOWN_VALUES]: ['Under Process','Paid', 'Waiver'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
  ],
};

// ***********************************************
export const PvpdInitData = {
  [PROTOCOL_NUMBER]: "",
  [PROTOCOL_NUMBER_OTHERS]: "",
  [MICR]: "",
  [TITLE]: "",
  [TYPE_OF_STUDY]: "",
  [SPONSOR]: "",
  [PRINCIPAL_INVESTIGATOR]: "",
  [CO_INVESTIGATOR]: "",
  [DEPARTMENT]: "",
  [DATE_OF_EVENT]: moment().format("yyyy-MM-DD"),
  [TYPE_OF_PV_PD]: "",
  [DOCUMENTS]: [
    {
      [LABEL]: "Cover letter",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
    },
  ],
};

export const PvpdStudyDetailsValidationStepOne = yup.object().shape({
  [PROTOCOL_NUMBER]: yup.string().required("Protocol is required"),
  [MICR]: yup.string().required("MICR is required"),
  [TITLE]: yup.string().required("Study title is required"),
  [SPONSOR]: yup.string().required("Sponsor name is required"),
  [PRINCIPAL_INVESTIGATOR]: yup
    .string()
    .required("Principal investigator name is required"),
  [DEPARTMENT]: yup.string().required("Department is required"),
  [DATE_OF_EVENT]: yup.date().required("Date of event is required"),
});

export const PvpdStudyDetailsValidationStepTwo = yup.object().shape({
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        [LABEL]: yup.string().required("Label is required"),
        [REQUIRED]: yup.boolean().required(),
        [_URL]: yup.string().when(REQUIRED, {
          is: true,
          then: yup.string().test(_URL, function (value) {
            const label = this.parent[LABEL] || "";
            return (
              Boolean(value) ||
              this.createError({ message: `Please add ${label} document` })
            );
          }),
          otherwise: yup.string(),
        }),
      })
    )
    .required("At least one document is required")
    .min(1),
});

export const PvpdStudyDetailsValidation = [
  PvpdStudyDetailsValidationStepOne,
  PvpdStudyDetailsValidationStepTwo,
];

// ***********************************************

export const SaeInitData = (type: string) => {
  let obj = {
    [PROTOCOL_NUMBER]: "",
    [MICR]: "",
    [TITLE]: "",
    [SPONSOR]: "",
    [PRINCIPAL_INVESTIGATOR]: "",
    [DEPARTMENT]: "",
    [STUDY_PHASE]: "",
    [TYPE_OF_STUDY]: "",
    [FUND_TYPE]: "",
    [IS_FUNDED]: false,
    [DOCUMENTS]: [
      {
        [LABEL]: "Cover letter",
        [REQUIRED]: true,
        [_URL]: "",
        [IS_EDITABLE]: false,
        [IS_INPUT_OPENED]: false,
      },
      {
        [LABEL]: "Table 5",
        [REQUIRED]: true,
        [_URL]: "",
        [IS_EDITABLE]: false,
        [IS_INPUT_OPENED]: false,
      },
      {
        [LABEL]: "Supporting documents",
        [REQUIRED]: true,
        [_URL]: "",
        [IS_EDITABLE]: false,
        [IS_INPUT_OPENED]: false,
      },

      {
        [LABEL]: "Death Certificate (If applicable) :",
        [REQUIRED]: false,
        [_URL]: "",
        [IS_EDITABLE]: false,
        [IS_INPUT_OPENED]: false,
      },
    ],
  };

  if (type === SAE_SUB_SECTIONS.FINAL_AND_ANALYSED_REPORT) {
    obj = {
      ...obj,
      documents: [
        ...obj.documents,
        {
          [LABEL]: "Causality assessment document",
          [REQUIRED]: true,
          [_URL]: "",
          [IS_EDITABLE]: false,
          [IS_INPUT_OPENED]: false,
        },
      ],
    };
  }
  if (type === SAE_SUB_SECTIONS.FOLLOW_UP_1) {
    obj = {
      ...obj,
      documents: [
        ...obj.documents,
        {
          [LABEL]: "Causality assessment document",
          [REQUIRED]: false,
          [_URL]: "",
          [IS_EDITABLE]: false,
          [IS_INPUT_OPENED]: false,
        },
      ],
    };
  }
  if (type === SAE_SUB_SECTIONS.FOLLOW_UP_2) {
    obj = {
      ...obj,
      documents: [
        ...obj.documents,
        {
          [LABEL]: "Causality assessment document",
          [REQUIRED]: false,
          [_URL]: "",
          [IS_EDITABLE]: false,
          [IS_INPUT_OPENED]: false,
        },
      ],
    };
  }
  return obj;
};

export const SaeStepValidationStep1 = yup.object().shape({
  [PROTOCOL_NUMBER]: yup.string().required("Protocol is required"),
  [MICR]: yup.string().required("MICR is required"),
  [TITLE]: yup.string().required("Study title is required"),
  [SPONSOR]: yup.string().required("Sponsor name is required"),
  [PRINCIPAL_INVESTIGATOR]: yup
    .string()
    .required("Principal investigator name is required"),
  [DEPARTMENT]: yup.string().required("Department is required"),
  [STUDY_PHASE]: yup.string().nullable().required("Study phase is required"),
  [TYPE_OF_STUDY]: yup.string().required("Types of study is required"),
  [FUND_TYPE]: yup.string(),
  // isTermsAccepted: yup
  //   .boolean()
  //   .isTrue("Please accept the terms first.")
  //   .required("Please accept the terms first."),
});

export const SaeStepValidationStep2 = yup.object().shape({
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        [LABEL]: yup.string().required("Label is required"),
        [REQUIRED]: yup.boolean().required(),
        [_URL]: yup.string().when(REQUIRED, {
          is: true,
          then: yup.string().test(_URL, function (value) {
            const label = this.parent[LABEL] || "";
            return (
              Boolean(value) ||
              this.createError({ message: `Please add ${label}` })
            );
          }),
          otherwise: yup.string(),
        }),
      })
    )
    .required("At least one document is required")
    .min(1),
});

export const SaeStepValidation = [
  SaeStepValidationStep1,
  SaeStepValidationStep2,
];

// ***********************************************
export const StudyCloseInitData = {
  [PROTOCOL_NUMBER]: "",
  [MICR]: "",
  [TITLE]: "",
  [SPONSOR]: "",
  [PRINCIPAL_INVESTIGATOR]: "",
  [CO_INVESTIGATOR]: "",
  [DEPARTMENT]: "",
  [STUDY_PHASE]: "",
  [TYPE_OF_STUDY]: "",
  [FUND_TYPE]: "",
  [IS_FUNDED]: false,
  [DOCUMENTS]: [
    {
      [LABEL]: "Cover letter",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
    },
    {
      [LABEL]: "Study completion/termination report",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
    },
    {
      [LABEL]: "Supporting documents",
      [REQUIRED]: false,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
    },
    {
      [LABEL]: "EC fees",
      [REQUIRED]: true,
      [_URL]: "",
      [IS_EDITABLE]: false,
      [IS_INPUT_OPENED]: false,
      [DROPDOWN_VALUES]: ['Under Process','Paid', 'Waiver'],
      [DROPDOWN_SELECTED_VALUE]: '',
    },
  ],
};

export const SAE_SUB_SECTIONS = {
  INITIAL_REPORT: "Initial Report",
  FOLLOW_UP_1: "Follow up 1",
  FOLLOW_UP_2: "Follow up 2",
  FINAL_AND_ANALYSED_REPORT: "Final and Analysed Report",
};

export const STUDY_CLOSEOUT_REPORT_SUB_SECTIONS = {
  STUDY_COMPLETION_REPORT: "Study Completion Report",
  STUDY_TERMINATION_REPORT: "Study Termination Report",
};